import React from "react";
import { createRoot } from "react-dom/client";
import "unfonts.css";

import { amplifyConfigure } from "@services/amplify/index";
import { enableMocking } from "./mocks/start";
import { App } from "./App";

amplifyConfigure();
void enableMocking().then(() => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
});
